import { CUSTOM_CELL_COMPONENTS as r, CUSTOM_HEADERS_COMPONENTS as O } from "./index.es531.js";
const m = ({
  headerComponent: t,
  cellType: o
}) => {
  let e;
  t && (e = Object.keys(t).filter((s) => s !== "testId")[0]);
  const C = O[e], n = r[o];
  return { HeaderComponent: C, CellComponent: n };
};
export {
  m as getCustomCellingComponents
};
//# sourceMappingURL=index.es2349.js.map
